module.exports = __webpack_public_path__ + "assets/img/5a56-xk.svg";